import type { AssetGraphViewMode } from './AssetWorkspaceViews';

const WORKSPACE_VIEW_SET = new Set<AssetGraphViewMode>(['fitted', 'related', 'practice']);

export function parseAssetWorkspaceView(raw: string | undefined | null): AssetGraphViewMode {
  const value = String(raw || '').trim();
  if (WORKSPACE_VIEW_SET.has(value as AssetGraphViewMode)) {
    return value as AssetGraphViewMode;
  }
  return 'fitted';
}

/** `/assets/:assetId/:view` — fitted uses the shorter canonical path. */
export function buildAssetWorkspacePath(
  assetId: string,
  view: AssetGraphViewMode = 'fitted',
  search?: Record<string, string | null | undefined>,
): string {
  const id = String(assetId || '').trim();
  const base = view === 'fitted'
    ? `/assets/${encodeURIComponent(id)}`
    : `/assets/${encodeURIComponent(id)}/${view}`;
  if (!search) return base;
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(search)) {
    const trimmed = String(value || '').trim();
    if (trimmed) params.set(key, trimmed);
  }
  const qs = params.toString();
  return qs ? `${base}?${qs}` : base;
}

export function isAssetWorkspaceViewParam(value: string | undefined | null): value is AssetGraphViewMode {
  return WORKSPACE_VIEW_SET.has(String(value || '').trim() as AssetGraphViewMode);
}
